import script from "./rBarHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./rBarHistory.vue?vue&type=script&setup=true&lang=ts"

import "./rBarHistory.vue?vue&type=style&index=0&id=2cbbc9bf&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cbbc9bf"]])

export default __exports__